import DeleteIcon from 'assets/icons/delete';
import { IconButton } from '@mui/material';

const FileDeleteIconButton = ({ onClick, disabled = false }) => {
	return (
		<IconButton sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px' }} onClick={onClick} disabled={disabled}>
			<DeleteIcon color="#ff4d4f" width="20px" height="20px" />
		</IconButton>
	);
};

export default FileDeleteIconButton;
